import type { Component } from "solid-js";
import { twMerge } from "tailwind-merge";
import { Button } from "~/solidJs/shared/ui";
import LogoIcon from "~/solidJs/shared/ui/atoms/Icons/Logo.svg?component-solid";
import LogoNewIcon from "~/solidJs/shared/ui/atoms/Icons/logoNew.svg?component-solid";
import classes from "./Logo.module.sass";

type LogoProps = {
	class?: string;
	onClick?: (e: MouseEvent) => void;
};

export const Logo: Component<LogoProps> = (_props) => {
	return (
		<Button component={"a"} href={"/"} class={classes.logo}>
			<LogoIcon class={classes.icon} />
		</Button>
	);
};

export const LogoNew: Component<LogoProps> = (props) => {
	return (
		<div
			onClick={props.onClick}
			class={twMerge(props.onClick && "cursor-pointer", props.class)}
		>
			<LogoNewIcon class="h-6 text-text-primary" />
		</div>
	);
};
